<!--
 * @FileDescription: 多图图片模板（注释描述）
 * @Author:xy（作者）
 * @Date: 2020-04-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
    <div class="picture">
        <div class="picture-item">
            <template  v-if="mainimgUrl.length > 0">
                <viewer :images="mainimgUrl">
                    <div class="picture-disply">
                        <div  class="picture-img" v-for="(item,index) in mainimgUrl" :key="index">
                            <img  :src="item.resourceUrl" alt="图片" />
                            <img src="@/assets/image/default_img@2x.png" class="picture-img-default"/>
                            <div class="picture-img-delete">
                                <div class="picture-delete-item">替换图片
                                    <input type="file" id="inputmain" ref="thumbnailmain" accept="image/*" @change="onImagemain(2)"/>
                                </div>
                                <div class="picture-delete-item"  @click="onDeletemain()">删除</div>
                            </div>
                        </div>
                    </div>
                </viewer>
            </template>
            <template v-else>
                <div  class="picture-left">
                    <img src="@/assets/image/default_img@2x.png" class="picture-img-main"/>
                    <input type="file" id="inputmain" ref="thumbnailmain" accept="image/*" @change="onImagemain(1)"/>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                        上传图片
                    </div>
                </div>
            </template>
        </div>
        <div class="picture-item" style="margin-left:28px">
            <template  v-if="imgUrl">
                <viewer :images="imgUrl">
                    <div class="picture-disply">
                        <div  class="picture-img" v-for="(item,index) in imgUrl" :key="index">
                            <img  :src="item.resourceUrl" alt="图片" />
                            <div class="picture-img-delete">
                                <div class="picture-delete-item">替换图片
                                    <input type="file" id="inputmain" ref="thumbnailti" accept="image/*" @change="onImagemain(3,item)"/>
                                </div>
                                <div class="picture-delete-item"  @click="onDelete(item,index)">删除</div>
                            </div>
                        </div>
                    </div>
                </viewer>
            </template>
            <template v-if="imgIndex < index">
                <div  class="picture-left">
                    <input type="file" id="input" ref="thumbnail" accept="image/*" @change="onImage" multiple="multiple"/>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                        上传图片
                    </div>
                </div>
                <!--<div class="picture-right" v-show="isRemarks">仅支持PNG、JPG等格斯</div>-->
            </template> 
        </div>
    </div>
</template>
<script>
    //图片放大
    import {uploadMultiFile,uploadFile} from "@/utils/api";
    import 'viewerjs/dist/viewer.css'
    import Viewer from "v-viewer/src/component.vue"
    export default {
        props:{
            isRemarks:{
                type:Boolean,
                default:true
            },
            isMore:{
                type: Boolean,
                default:true
            },
            index:{
                type:Number,
                default:4
            },
        },
        data() {
            return {
                imgUrl:[],
                loading:false,
                imgIndex:0,
                mainimgUrl:[],
            }
        },
        methods: {
            onOpen(value,value1){
                this.imgIndex = 0
                if(value.length > 0){
                    this.imgUrl = []
                    value.forEach((item)=>{
                        this.imgUrl.push(item)
                    })
                }else{
                    this.imgUrl = []
                }
                if(JSON.stringify(value1) != "{}"){
                    this.mainimgUrl = []
                    this.mainimgUrl.push(value1)
                }else{
                    this.mainimgUrl = []
                }
            },
            onImagemain(index,record){
                let imageFile = ''
                if(index == 1){
                    imageFile = this.$refs.thumbnailmain.files[0]
                }else if(index == 2){
                    imageFile = this.$refs.thumbnailmain[0].files[0]
                }else{
                    imageFile = this.$refs.thumbnailti[0].files[0]
                }
                $('#inputmain').val('')
                var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG|gif)$/;
                if (!this.isEmpty(imageFile) && imgStr.test(imageFile.name)) {
                    if (imageFile.size >  1024 * 1024) {
                        this.$message.warn('图片大于1兆,请重试')
                        return;
                    }
                    var form = new FormData()
                    form.append("file",imageFile,imageFile.name)
                    form.append("type","store")
                    uploadFile(form,{
                        'Content-Type':'multipart/form-data'
                    }).then((res)=>{
                        if(res.success){
                            if(index == 1 || index == 2){
                                res.result.resourceUrl = res.result.resource_url
                                res.result.resourceId = res.result.id
                                this.mainimgUrl = []
                                this.mainimgUrl.push(res.result)
                                this.$emit('onChangeImgmain',res.result)
                            }else if(index == 3){
                                record.resourceUrl = res.result.resource_url
                                record.resourceId = res.result.id
                            }
                        }
                    })
                }else{
                    this.$message.warn('请检查图片格式')
                }
            },
            /**
             * @description: 此为方法注释（方法描述）
             */
            onImage(){
                let index = 0
                let imageFile = this.$refs.thumbnail.files
                var form = new FormData()
                if(imageFile.length > 0 && this.imgIndex+imageFile.length <= this.index){
                    var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
                    for(let i = 0;i<imageFile.length;i++){
                        if(imgStr.test(imageFile[i].name)){
                            if(imageFile[i].size > 1024*1024 ){
                                index++
                                this.$message.warn('图片太大，请压缩至1M以下')
                            }else{
                                form.append("file",imageFile[i])
                            }
                        }else{
                            this.$message.warn('请确认图片的格式')
                        }
                    }
                    if(index !== imageFile.length){
                        form.append("type","store")
                        uploadMultiFile(form,{
                            'Content-Type':'multipart/form-data'
                        }).then((res)=>{
                            $('#input').val('')
                            $('#inputmain').val('')
                            if(res.success){
                                res.result.forEach((item)=>{
                                    this.imgUrl.push({
                                        resourceUrl:item.resource_url,
                                        resourceId:item.id,
                                    })
                                })
                                this.imgIndex = this.imgIndex + res.result.length
                                this.$message.success(res.logMessage)
                                this.$emit('onChangeImg',this.imgUrl)

                            }else{
                                if(res.result.length > 0){
                                    res.result.forEach((item)=>{
                                        if(item.success == 'true'){
                                            this.imgUrl.push({
                                                resourceUrl:item.resource_url,
                                                resourceId:item.id,
                                            })
                                        }
                                    })
                                    this.imgIndex = this.imgIndex + this.imgUrl.length
                                }
                                this.$emit('onChangeImg',this.imgUrl)
                                this.$message.warn(res.logMessage)

                            }
                        })
                    }
                }else{
                    this.$message.warn('只能上传5张图片')
                }
            },
            /**
             * @description: 删除（方法描述）
             */
            onDelete(item,index){
                this.$comm.removeByIndex(this.imgUrl,index)
                this.imgIndex = this.imgIndex - 1
                this.$emit('onChangeImg',this.imgUrl)
            },
            onDeletemain(){
                this.mainimgUrl = []
            }
        },
        components:{
            Viewer

        },
        watch:{
        },
        mounted(){

        },
        created(){

        }
    }
</script>
<style lang="scss" scoped>
    .picture{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .picture-item{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .picture-left{
        cursor: pointer;
        width:160px;
        height:160px;
        background:#FAFAFA;
        border:1px dashed #DDDDDD;
        border-radius:2px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .picture-img-main{
            position: absolute;
            top: 0;
            right: 0;
             width: 51px;
            height: 40px;
        }
        &:hover{
            border-color:var(--co);
            .anticon-plus{
                color: var(--co) !important;
            }
            .ant-upload-text{
                color:var(--co);
            }
        }
        .anticon-plus{
            font-size: 30px;
            color: #DDDDDD;
        }

        input{
            position: absolute;
            top: 0;
            left: 0;
            width: 160px;
            height: 160px;
            display: inline-block;
            opacity: 0;
        }
        img{
            width: 26px;
            margin-bottom: 14px;
        }
        .ant-upload-text{
            line-height: 15px;
            color: #AAAAAA;
            font-size: 14px;
            margin-top: 5px;
        }

    }
    .picture-disply{
        display: flex;
    }
    .picture-right{
        color:var(--co);
        font-size: 14px;
        padding-left: 20px;
    }
    .picture-img{
        width: 160px;
        height: 160px;
        position: relative;
        margin-right: 20px;
        margin-bottom: 20px;
        &:hover{
            .picture-img-delete{
                opacity: 1;
            }
        }
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .picture-img-default{
            width: 51px;
            height: 40px;
            position: absolute;
            top: 0;
            right: 0;
        }
        .picture-img-delete{
            opacity: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            background:rgba(0,0,0,0.5);
            bottom: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .picture-delete-item{
                cursor: pointer;
                width: 100px;
                height: 26px;
                background:rgba(51,51,51,0.6);
                color: #fff;
                line-height: 26px;
                text-align: center;
                margin-bottom: 8px;
                position: relative;
                input{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100px;
                    height: 26px;
                    display: inline-block;
                    opacity: 0;
                }
            }
        }
    }
</style>
